import { GET_BOAT_RECIPES_SUCCESS } from "../actionTypes";

const initialState = []

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_BOAT_RECIPES_SUCCESS: {
      const boatRecipes = action.payload;

      if (!boatRecipes){
        return {...state};
      }

      return [...state, ...action.payload]
    }

    default:
      return state;
  }
}
